// extracted by mini-css-extract-plugin
module.exports = {"sticker":"Sticker_sticker__3i4Yd","image":"Sticker_image__31yHv"};